import { setProgressPanelExpanded } from '../../../actions/WizardActions';
import { useEffect } from 'react';
import WizardProgressInfoPanel from '../../../components/Wizard/WizardProgressInfoPanel';
// @ts-expect-error Could not find a declaration file for module
import personImageUrl from 'bender-url!../../../../images/wizard-person.svg';
import WizardActions, { CloseButtonComponent } from '../../../components/Wizard/WizardActions';
import WizardCategories from '../../../components/Wizard/WizardCategories';
import { useDispatch } from 'react-redux';
import WizardTools from '../../../components/Wizard/WizardTools';
import WizardTitle, { WizardSubtitle } from '../../../components/Wizard/WizardTitle';
import UsageTracker from '../../../utils/UsageTracker';
import { useHistory, useLocation } from 'quartz-routing/react-router';
import { NavMarker } from 'react-rhumb';
import { SCREENS } from '../../../constants/Tracking';
import { useCurrentLearningInterest, useSubmitWizardResults, useWizardProgress } from '../wizardQueries';
import { WizardLanguageToggle } from './WizardLanguageToggle';
import WizardResults from './WizardResults';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useWizardResults } from '../wizardHooks';
import WizardChooseMotivation from './WizardChooseMotivation';
import { useWizardNavigation } from '../wizardRouting';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { EditorPage } from 'foundations-components/transitional/components/EditorPage';
import { View } from 'foundations-components/transitional/components/View';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { Image } from 'foundations-components/transitional/components/Image';
import { HubSpotLogo } from 'academy-common-lib/features/profile/components/Header';
import { isNewCatalogUser } from '../../../utils/utils';

// Wizard page: orchestrates step flow, layout, and actions
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WizardPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    isMobile
  } = useMediaQuery();
  const {
    goForward,
    goBack
  } = useWizardNavigation();
  const location = useLocation();
  const isNewUser = isNewCatalogUser(location.search);
  const {
    wizardProgress,
    currentStep
  } = useWizardProgress();
  const isFinalStep = currentStep === 'final';
  const hideProgress = currentStep === 'initial';
  const learningInterest = useCurrentLearningInterest();
  const {
    searchResults,
    resultsCount,
    isRequesting,
    selectedCategoryGroup,
    selectedToolsGroup,
    isToolsSelected,
    resultsUrl,
    searchCriteria,
    correlationId
  } = useWizardResults({
    learningInterest
  });
  const backClick = () => {
    goBack();
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-back'
    });
  };
  useSubmitWizardResults({
    resultCount: resultsCount,
    wait: isRequesting
  });
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.WIZARD
    });
  }, []);
  const closeWizard = () => {
    history.push('/');
  };
  const setCertsOnly = certsOnly => {
    goForward(certsOnly);
  };
  const openProgressPanelMobile = () => {
    dispatch(setProgressPanelExpanded(true));
  };
  const onClickProgressPanel = () => {
    dispatch(setProgressPanelExpanded(false));
  };
  const onClickCancel = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-cancel'
    });
    closeWizard();
  };

  // Renders the progress panel (desktop left or mobile inline)
  const renderProgressPanel = () => {
    return /*#__PURE__*/_jsx(WizardProgressInfoPanel, {
      isRequesting: isRequesting,
      languageToggle: /*#__PURE__*/_jsx(WizardLanguageToggle, {
        showMoreContentInEnglishTooltip: resultsCount > 0 || isRequesting ? undefined : true
      }),
      onSetExpanded: expand => dispatch(setProgressPanelExpanded(expand)),
      onStepClick: onClickProgressPanel,
      resultsCount: resultsCount
    });
  };

  // Final step content: results list and CTA
  const renderWizardResults = () => {
    return /*#__PURE__*/_jsx(WizardResults, {
      catalogUrl: resultsUrl,
      correlationId: correlationId,
      isRequesting: isRequesting,
      onOpenResultsClick: openProgressPanelMobile,
      results: searchResults,
      totalResultCount: resultsCount
    });
  };

  // Motivation selection step
  const renderWizardMotivation = () => {
    return /*#__PURE__*/_jsx(WizardChooseMotivation, {
      isRequesting: isRequesting,
      onMotivationClick: setCertsOnly,
      resultCountTotal: resultsCount,
      searchCriteria: searchCriteria
    });
  };
  const onSelectOption = option => {
    goForward(option);
  };

  // Category/tool selection step
  const renderCategories = () => {
    return isToolsSelected ? /*#__PURE__*/_jsx(WizardTools, {
      onOptionSelect: onSelectOption
    }) : /*#__PURE__*/_jsx(WizardCategories, {
      onOptionSelect: onSelectOption
    });
  };

  // Left column (desktop): image on initial step, otherwise progress panel
  const renderWizardLeftContent = () => {
    if (isMobile) return null;
    if (hideProgress) {
      return /*#__PURE__*/_jsx(View, {
        inlineSize: "350px",
        children: /*#__PURE__*/_jsx(Image, {
          "data-test-id": "wizard-left-image",
          margin: "0",
          src: personImageUrl
        })
      });
    }
    return renderProgressPanel();
  };

  // Right column: step-specific main content
  const renderWizardRightContent = () => {
    switch (currentStep) {
      case 'final':
        return renderWizardResults();
      case 'motivation':
        return renderWizardMotivation();
      default:
        return renderCategories();
    }
  };
  const showCloseButton = currentStep === 'initial' && !isNewUser;

  // Header logo (desktop only)
  const renderLogo = () => {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      paddingBlockStart: "500",
      paddingInline: "1000",
      children: [/*#__PURE__*/_jsx(HubSpotLogo, {}), showCloseButton && /*#__PURE__*/_jsx(CloseButtonComponent, {
        onClick: onClickCancel
      })]
    });
  };

  // Title above the main step content
  const renderWizardTitle = () => {
    return /*#__PURE__*/_jsx(WizardTitle, {
      catGroup: isToolsSelected ? selectedToolsGroup : selectedCategoryGroup,
      isMobile: isMobile
    });
  };
  const hideTitle = isFinalStep && resultsCount < 1;
  return /*#__PURE__*/_jsx(EditorPage, {
    headerComponent: null,
    mainSectionFlush: true,
    scrollDirection: "none",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "stretch",
      blockSize: "100%",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "WIZARD_VIEW_LOADED"
      }), /*#__PURE__*/_jsx(View, {
        marginInline: "-100",
        children: /*#__PURE__*/_jsx(Progress, {
          "data-test-id": "wizard-progress-bar",
          marginBlock: "0",
          use: isFinalStep ? 'success' : 'warning',
          value: wizardProgress
        })
      }), isMobile && !hideProgress && renderProgressPanel(), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flex: 1,
        flexDirection: "column",
        overflowY: "auto",
        children: [!isMobile && renderLogo(), /*#__PURE__*/_jsxs(View, {
          children: [currentStep !== 'initial' && /*#__PURE__*/_jsx(WizardActions, {
            catalogUrl: resultsUrl,
            isNewUser: isNewUser,
            onBackLinkClick: backClick,
            onCancelClick: onClickCancel,
            totalResultCount: resultsCount
          }), /*#__PURE__*/_jsx(View, {
            padding: isMobile ? '300' : '0',
            children: /*#__PURE__*/_jsxs(View, {
              marginInline: "auto",
              maxInlineSize: isMobile ? '100%' : '1700px',
              children: [!isMobile && !hideTitle && /*#__PURE__*/_jsxs(Flex, {
                alignItems: "start",
                gap: "1400",
                children: [/*#__PURE__*/_jsx(Box, {
                  flexShrink: 0,
                  inlineSize: "350px"
                }), /*#__PURE__*/_jsx(Box, {
                  flex: 1,
                  children: renderWizardTitle()
                })]
              }), /*#__PURE__*/_jsxs(Flex, {
                alignItems: isMobile ? 'stretch' : 'start',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? undefined : '600',
                paddingInline: "1000",
                children: [!isMobile && /*#__PURE__*/_jsx(Box, {
                  flexShrink: 0,
                  inlineSize: "350px",
                  children: renderWizardLeftContent()
                }), isMobile && !hideTitle && /*#__PURE__*/_jsx(Box, {
                  children: renderWizardTitle()
                }), /*#__PURE__*/_jsxs(Box, {
                  flex: 1,
                  minInlineSize: isMobile ? undefined : '0',
                  children: [/*#__PURE__*/_jsx(WizardSubtitle, {
                    isMobile: isMobile
                  }), renderWizardRightContent()]
                })]
              })]
            })
          })]
        })]
      })]
    })
  });
};
export default WizardPage;